<template>
  <div class="athena-login">
    <div class="container">
      <h2>{{ $t('login.login') }}</h2>
      <p class="error page_text_font" v-html="error_email"></p>
      <p class="error page_text_font" v-html="error_forgote"></p>
      <form method="POST" action="/login">
        <input type="hidden" name="_token" :value="token" />
        <!-- Login Page -->
        <div v-if="type == 'login'">
          <!-- Email -->
          <div class="row">
            <div class="email col-12">{{ $t("login.email") }}</div>
            <input
              v-model="email"
              type="email"
              class="form-control page_text_font"
              :class="email_style"
              @click="email_style = 'active_focus'"
              @blur="email_style = ''"
              name="email"
              required
              autocomplete="email"
              autofocus
            />
          </div>
          <!-- Password -->
          <div class="row">
            <div class="flex-password col-12">
              <div class="password">
                {{ $t("login.password") }}
              </div>
              <h5>
                <a @click="type = 'forget'" style="cursor: pointer">
                  {{ $t("login.forgot_password") }}
                </a>
              </h5>
            </div>
            <input
              id="password"
              type="password"
              class="form-control page_text_font"
              name="password"
              required
              autocomplete="current-password"
              :class="password_style"
              @click="password_style = 'active_focus'"
              @blur="password_style = ''"
            />
          </div>
          <!-- Sign up -->
          <div class="row sign-up-xl">
            <h5 style="margin-top: 8px">
              <a href="/account/register" class="col-12 sign-up" style="text-transform: capitalize">
                {{ $t('new_customer') }}? {{ $t('sign_up') }} >
              </a>
            </h5>
          </div>
          <!-- Login in -->
          <div class="row" style="margin-top: 18px">
            <button
              @click="save"
              type="submit"
              class="col-12 col-md-auto"
              id="loginbtn"
              style="padding: 9px 20px"
            >
              <span>{{ $t('login.login') }}</span>
            </button>
            <v-social-auth v-if="social_auth" :social_auth="social_auth" class="col-12 col-md-7 text-md-right text-center" style="display:inline-block;margin: 0 0 0 auto;"></v-social-auth>
          </div>
          <div class="row sign-up-md">
            <h5>
              <a href="/account/register" class="col-12 sign-up" style="text-transform: capitalize">
                {{ $t('new_customer') }}? {{ $t('sign_up') }} >
              </a>
            </h5>
          </div>
        </div>
      </form>
      <!-- Forget Page -->
      <div v-if="type == 'forget'" class="forget">
        <h3>Reset Password</h3>
        <p class="error page_text_font" v-html="error_email"></p>
        <p class="error page_text_font" v-html="error_forgote"></p>
        <!-- Email -->
        <form method="POST" action="/password/email">
          <input type="hidden" name="_token" :value="token" />
          <div class="row">
            <div class="email col-12">{{ $t("login.email") }}</div>
            <input
              v-model="email"
              type="email"
              class="form-control page_text_font"
              :class="email_style"
              name="email"
              required
              autocomplete="email"
              autofocus
              @click="email_style = 'active_focus'"
              @blur="email_style = ''"
            />
          </div>
          <p class="text-md-left">{{ $t("login.send_email") }}</p>
          <div style="margintop: 6px">
            <button
              type="submit"
              id="forgotbtn"
              class="col-12 col-md-auto"
              style="padding: 9px 20px; margin-bottom: 30px"
            >
              <span>{{ $t("login.submit") }}</span>
            </button>
            <span @click="type = 'login'" class="col-12 col-md-3 cancel">{{
              $t("login.cancel")
            }}</span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import vSocialAuth  from "@/js/components/view/socialauth/index.vue"
export default {
  props: ["error_email", "error_forgote", "social_auth"],
  data() {
    return {
      type: "login",
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      email: "",
      password_style: "",
      email_style: "",
    };
  },
  methods: {
    save() {
      window.localStorage.setItem("login_email", this.email);
      //登录时snapchat的 LOGIN 事件
      if(window.snaptr){
        window.snaptr('track', 'LOGIN')
      }
    },
  },
  beforeMount() {
    console.log(this.social_auth);
    if (window.location.hash == "#recover") {
      this.type = "forget";
    } else {
      this.type = "login";
    }
    if (this.error_email || this.error_forgote) {
      this.email = window.localStorage.getItem("login_email");
      this.password_style = "active_error";
      this.$axios.post(API.statis_event, {
        name: 'login',
        parameters: { username: this.email, success: false },
      }) 
    }
  },
  components:{
    vSocialAuth,
  }
};
</script>
<style scoped lang='scss'>
.athena-login {
  margin: 30px 0 42px;
  .container {
    max-width: 520px;
    font-family: Roboto-Regular;
    color: #222a40;
    .error {
      color: red;
      font-size: 14px;
      text-align: center;
    }
    .row {
      margin: 0;
    }
    .flex-password {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 28px 0 20px 0;
      padding: 0;
    }
    h2 {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #222a40;
      margin: 100px 0 60px 0;
    }
    .email,
    .password {
      padding: 0;
      font-size: 24px;
      font-weight: 400;
      color: #222a40;
    }
    .email {
      margin-bottom: 20px;
    }
    input {
      border-radius: 0;
      height: 48px;
      line-height: 22px;
      padding: 12px;
      color: #1e0909;
      vertical-align: middle;
      border: 1px solid #e4e4e4;
      width: 100%;
      margin-bottom: 12px;
      cursor: pointer;
    }
    .sign-up {
      padding: 0;
    }
    .sign-up-md {
      display: none;
      h5 {
        width: 100%;
        text-align: center;
        margin-top: 30px;
      }
      a {
        text-align: center;
      }
    }
    .forget {
      h3 {
        margin-bottom: 29px;
      }
      p {
        margin: 8px 0 40px 0;
        font-size: 16px;
      }
      .cancel {
        cursor: pointer;
        text-decoration: underline;
        text-align: center;
        display: inline-block;
        font-size: 20px;
      }
    }
    #loginbtn,
    #forgotbtn {
      background-color: #222a40;
      height: 52px;
      span {
        font-size: 24px;
        font-weight: 500;
        color: #fff;
      }
    }
  }
}
@media (max-width: 768px) {
  .athena-login {
    margin: 30px 0 42px;
    .container {
      padding: 0 15px;
      color: #222a40;
      .error {
        font-size: 14px;
      }
      .row {
        margin: 0;
      }
      .flex-password {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 12.5px 0 12px 0;
        padding: 0;
        h5 {
          font-size: 14px ;
        }
      }
      #password {
        margin-bottom: 8px;
      }
      h2 {
        font-size: 18px;
        margin: 37px 0 15px 0;
      }
      .email,
      .password {
        padding: 0;
        font-size: 14px;
      }
      .email {
        margin-bottom: 12px;
      }
      input {
        border-radius: 0;
        height: 40px;
        line-height: 22px;
        padding: 12px;
        width: 100%;
        margin-bottom: 12px;
      }
      .sign-up {
        padding: 0;
      }
      .sign-up-md {
        display: none;
        h5 {
          width: 100%;
          text-align: center;
          margin-top: 0;
          font-size: 13px;
        }
      }
      .forget {
        h3 {
          font-size: 14px;
          line-height: 21px;
          margin-bottom: 24.5px;
        }
        p {
          margin: 4px 0 20px 0;
          font-size: 13px;
        }
        .cancel {
          cursor: pointer;
          text-decoration: underline;
          text-align: center;
          display: inline-block;
          font-size: 14px;
        }
      }
      #loginbtn,
      #forgotbtn {
        height: 40px;
        margin-bottom: 15px !important;
        span {
          font-size: 15px;
          font-weight: 500;
          color: #fff;
        }
      }
    }
  }
  .sign-up-xl {
    display: none !important;
  }
  .sign-up-md {
    display: flex !important;
  }
}
</style>